import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import LandingPage from './pages/LandingPage';
import ProxiesPage from './pages/ProxiesPage';
import ResidentialProxiesPage from './pages/ResidentialProxiesPage';
import MobileProxiesPage from './pages/MobileProxiesPage';
import AboutPage from './pages/AboutPage';
import PricingPage from './pages/PricingPage';
import UseCasePage from './pages/UseCasePage';
import BlogPage from './pages/BlogPage';
import BlogIndexPage from './pages/BlogIndexPage';
import CareersPage from './pages/CareersPage';
import DocumentationPage from './pages/DocumentationPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import RefundPolicyPage from './pages/RefundPolicyPage';
import AcceptableUsePolicyPage from './pages/AcceptableUsePolicyPage';
import LegalNoticePage from './pages/LegalNoticePage';
import HubDocumentPage from './pages/HubDocumentPage';
import CookieBanner from './components/CookieBanner';
import useScrollToTop from './hooks/useScrollToTop';
import './App.css';

// Component to handle scroll to top on route changes
const ScrollToTopWrapper = ({ children }) => {
  useScrollToTop();
  return children;
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTopWrapper>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/proxies" element={<ProxiesPage />} />
              <Route path="/proxies/residential" element={<ResidentialProxiesPage />} />
              <Route path="/proxies/mobile" element={<MobileProxiesPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/pricing/:type" element={<PricingPage />} />
              <Route path="/use-cases" element={<UseCasePage />} />
              <Route path="/use-cases/:slug" element={<UseCasePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/blog" element={<BlogIndexPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/docs" element={<DocumentationPage />} />
              <Route path="/docs/:section" element={<DocumentationPage />} />
              <Route path="/docs/:section/:subsection" element={<DocumentationPage />} />
              <Route path="/docs/:section/:subsection/:subsubsection" element={<DocumentationPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/integrations" element={<BlogPage />} />
              <Route path="/integrations/:slug" element={<BlogPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-of-service" element={<TermsOfServicePage />} />
              <Route path="/cookie-policy" element={<CookiePolicyPage />} />
              <Route path="/refund-policy" element={<RefundPolicyPage />} />
              <Route path="/acceptable-use-policy" element={<AcceptableUsePolicyPage />} />
              <Route path="/legal" element={<LegalNoticePage />} />
              <Route path="*" element={<HubDocumentPage />} />
            </Routes>
            <CookieBanner />
          </ScrollToTopWrapper>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
